import Axios from "./axios";

const resource = "form-emails";

export default {
  createViaKey(key,data) {
		return Axios.post(`${resource}/${key}`, data);
	},
	applyNow(data) {
		return Axios.post(`${resource}/apply-now`, data);
	}
}